import { createFileRoute } from "@tanstack/react-router";
import { socialImageMeta } from "@/lib/og";
import { LegalLayout, LegalSection } from "@/components/site/LegalLayout";

export const Route = createFileRoute("/integritet")({
  head: () => ({
    meta: [
      { title: "Integritetspolicy — Skolvyn" },
      { name: "description", content: "Så behandlar Skolvyn dina personuppgifter enligt GDPR. Läs om ändamål, lagringstider och dina rättigheter." },
      { property: "og:title", content: "Integritetspolicy — Skolvyn" },
      { property: "og:description", content: "Så behandlar Skolvyn dina personuppgifter enligt GDPR." },
    
        ...socialImageMeta({ path: "/integritet" }),
      ],
    links: [{ rel: "canonical", href: "https://skolvyn.se/integritet" }],
  }),
  component: Integritet,
});

function Integritet() {
  return (
    <LegalLayout
      eyebrow="Juridik"
      title="Integritetspolicy"
      updated="15 juli 2026"
      intro="Skolvyn AB värnar om din integritet. Här beskriver vi vilka personuppgifter vi samlar in, varför vi gör det och hur du utövar dina rättigheter enligt dataskyddsförordningen (GDPR)."
    >
      <LegalSection id="ansvarig" title="Personuppgiftsansvarig">
        <p>
          Skolvyn AB (org.nr 559XXX-XXXX), med säte i Stockholm, är personuppgiftsansvarig för behandlingen av dina
          personuppgifter på skolvyn.se. Kontakta oss på{" "}
          <a href="mailto:integritet@skolvyn.se">integritet@skolvyn.se</a>.
        </p>
      </LegalSection>

      <LegalSection id="uppgifter" title="Vilka uppgifter vi behandlar">
        <ul>
          <li>Konto- och kontaktuppgifter: namn, e-post, telefon, roll (vårdnadshavare, elev, kandidat, skoladmin).</li>
          <li>Innehåll du publicerar: intresseanmälningar, omdömen, jobbansökningar, meddelanden.</li>
          <li>Skolrelaterad information vid profilanspråk: organisation, org.nr, uppladdade underlag.</li>
          <li>Teknisk information: IP-adress, enhetstyp, webbläsare, tidsstämplar, användningsstatistik.</li>
        </ul>
      </LegalSection>

      <LegalSection id="andamal" title="Ändamål och rättslig grund">
        <ul>
          <li><strong className="text-ink">Leverera tjänsten</strong> (fullgörande av avtal): konton, sparade skolor, jämförelser, intresseanmälningar och jobbansökningar.</li>
          <li><strong className="text-ink">Verifiera profilanspråk</strong> (berättigat intresse): granska att sökande har mandat att företräda skolan.</li>
          <li><strong className="text-ink">Statistik och förbättring</strong> (samtycke via cookies): förstå hur sajten används.</li>
          <li><strong className="text-ink">Rättsliga skyldigheter</strong>: bokföring och skydd mot missbruk.</li>
        </ul>
      </LegalSection>

      <LegalSection id="delning" title="Vem vi delar uppgifter med">
        <p>
          Vi delar uppgifter med skolor du aktivt kontaktar (intresseanmälan, jobbansökan) och med personuppgiftsbiträden
          som driftar plattformen (molnhosting, e-post, analys). Alla biträden är bundna av personuppgiftsbiträdesavtal
          och behandlar uppgifter inom EU/EES där det är möjligt.
        </p>
      </LegalSection>

      <LegalSection id="lagring" title="Hur länge vi sparar uppgifter">
        <ul>
          <li>Kontouppgifter: så länge kontot är aktivt, samt 12 månader efter avslut.</li>
          <li>Intresseanmälningar och jobbansökningar: upp till 24 månader.</li>
          <li>Omdömen: så länge de är publicerade, därefter i logg 12 månader.</li>
          <li>
            Utskickslogg (mottagarens e-postadress, mall, tidpunkt och utfall för mejl vi skickat):
            12 månader, därefter raderas raden automatiskt.
          </li>
          <li>Bokföringsunderlag: 7 år enligt bokföringslagen.</li>

        </ul>
      </LegalSection>

      <LegalSection id="rattigheter" title="Dina rättigheter">
        <p>
          Du har rätt till information, tillgång, rättelse, radering, begränsning, dataportabilitet och att invända mot
          behandling som sker med stöd av berättigat intresse. Du kan när som helst återkalla lämnade samtycken. Kontakta
          oss på <a href="mailto:integritet@skolvyn.se">integritet@skolvyn.se</a>. Är du missnöjd med hur vi hanterar dina
          uppgifter kan du klaga hos Integritetsskyddsmyndigheten, <a href="https://www.imy.se" target="_blank" rel="noreferrer">imy.se</a>.
        </p>
      </LegalSection>

      <LegalSection id="andringar" title="Ändringar i policyn">
        <p>
          Vi kan uppdatera denna policy. Vid väsentliga ändringar meddelar vi dig via e-post eller på sajten innan de
          börjar gälla.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
